<template>
  <div class="main" v-title data-title="北京天蔚中医药发展促进中心-合作交流">
    <div class="swipe">
      <img src="http://123.56.170.62:9999/static/bg/banner6.png" alt />
    </div>
    <Class :nav="nav"></Class>
  </div>
</template>
<script>
import Class from "@/components/Class.vue"
import Bus from "@/utils/bus.js"
export default {
  data() {
    return {
      nav: [
        { title: "留言板", url: "lyb" },
        { title: "问题解答", url: "wtjd" },
        { title: "合作模式", url: "hzms" },
      ],
    }
  },
  mounted() {
    this.$nextTick(function() {
      Bus.$emit("getCurrent", "jlzx")
    })
  },
  methods: {},
  components: {
    Class,
  },
}
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  .swipe {
    width: 100%;
    img {
      width: 100%;
      height: 400px;
    }
  }
}
</style>
